import { withStyles } from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";

export const Accordion = withStyles({
  root: {
    boxShadow: "none",
    "& > :first-child": {
      borderTop: "unset",
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

export const AccordionSummary = withStyles({
  root: {
    flexDirection: "row-reverse",
    backgroundColor: "#f5f6f8",
    borderBottom: "1px solid #e8eaf0",
    borderTop: "1px solid #e8eaf0",
    marginBottom: 16,
    minHeight: 56,
    padding: "4px 24px",
    "&$expanded": {
      minHeight: 56,
    },
    "& .MuiAccordionSummary-expandIcon.Mui-expanded": {
      transform: "rotate(90deg)",
    },
    "& > .MuiIconButton-root": {
      padding: "unset",
      marginRight: 12,
    },
    "& > .MuiButtonBase-root": {
      cursor: "default",
    },
  },
  content: {
    justifyContent: "space-between",
    alignItems: "center",
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

export const AccordionDetails = withStyles(() => ({
  root: {
    padding: "0 16px 8px 16px",
  },
}))(MuiAccordionDetails);
